import { render, staticRenderFns } from "./AffiliateLandingPage.vue?vue&type=template&id=2ab9e871"
import script from "./AffiliateLandingPage.vue?vue&type=script&lang=js"
export * from "./AffiliateLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports